import { useState, useRef } from "react";
import PropTypes from "prop-types";

import { strCode } from "../../../../consts";
import { log, notificationService, t } from "../../../../services";

import WrapperContainer from "../../../Containers/WrapperContainer";
import FlexContainers from "../../../Containers/FlexContainers";
import { Paragraph2 } from "../../../Text/Paragraphs";
import { TextButton } from "../../../Buttons/styled";

import {
  DragFileWrapper,
  DrapAndDropWrapper,
  InputFileUploadLabel,
  SupportedFormatsInfo
} from "./styled";

const DragAndDropInput = ({ onUploadFile, error, setError }) => {
  const [dragActive, setDragActive] = useState(false);

  const inputRef = useRef(null);

  const handleUploadFile = (file) => {
    const extension = file?.type;

    if (extension !== "text/csv") {
      setError(true);
      log.warn("DragAndDropInput: Invalid file extension " + extension);

      notificationService.showError({
        title: t(strCode.FILE_FORMAT_ERROR_TITLE),
        message: t(strCode.FILE_FORMAT_ERROR_MESSAGE)
      });
    } else {
      setError(false);
      onUploadFile(file);
    }
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleUploadFile(e.dataTransfer.files[0]);
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      handleUploadFile(e.target.files[0]);
      e.target.value = "";
    }
  };

  const onButtonClick = () => {
    inputRef.current.click();
  };

  return (
    <WrapperContainer Container={FlexContainers.FlexColumnStart} width="100%">
      <DrapAndDropWrapper onDragEnter={handleDrag} onSubmit={(e) => e.preventDefault()}>
        <input
          data-testid="input-file-upload"
          ref={inputRef}
          type="file"
          accept=".csv"
          id="input-file-upload"
          onChange={(e) => handleChange(e)}
        />
        <InputFileUploadLabel
          id="label-file-upload"
          htmlFor="input-file-upload"
          dragActive={dragActive}
          hasError={error}>
          <WrapperContainer Container={FlexContainers.FlexRowCenter} gap={3}>
            <Paragraph2>
              {t(dragActive ? strCode.DROP_FILE_INFO : strCode.DRAG_AND_DROP_INFO)}
            </Paragraph2>
            {!dragActive && (
              <TextButton onClick={onButtonClick}>
                <Paragraph2>{t(strCode.CHOOSE_FILE_BTN)}</Paragraph2>
              </TextButton>
            )}
          </WrapperContainer>
        </InputFileUploadLabel>

        {dragActive && (
          <DragFileWrapper
            onDragEnter={handleDrag}
            onDragLeave={handleDrag}
            onDragOver={handleDrag}
            onDrop={handleDrop}></DragFileWrapper>
        )}
      </DrapAndDropWrapper>

      <WrapperContainer width={"100%"}>
        <SupportedFormatsInfo hasError={error}>
          {t(strCode.SUPPORTED_FORMATS_INFO)}
        </SupportedFormatsInfo>
      </WrapperContainer>
    </WrapperContainer>
  );
};

DragAndDropInput.propTypes = {
  onUploadFile: PropTypes.func.isRequired,
  error: PropTypes.bool,
  setError: PropTypes.func.isRequired
};

export default DragAndDropInput;
